export enum WishlistNodeType {
	Product,
	ProductCard,
	ProductSearch,
	ProductsYouMayAlsoLike,
	ArticleFeaturedProducts,
	WardrobeItemSearch,
	Wishlist,
}
